import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Breadcrumbs from '../../../shared/breadcrumbs/Breadcrumbs';
import '../../Technical.css';

class GetTopVoted extends Component {
    render() {
        return (
            <div className="technical-main">
                <Breadcrumbs />
                <div className="technical-content">
                    <h1 className="main-heading">
                        Competition API
                </h1>
                    <div>
                        <h2 className="main-subheading">
                            allaboutme.pcs.get_top_voted</h2>
                        <div className="technical-main-content">
                            <p>
                                Lists the top voted competition designs within a specified time period.</p>
                            <div>
                                <h3>
                                    Arguments</h3>
                                <ul>
                                    <li><b>api_key</b> (Required)
                                    <p>
                                            A valid API key that must be obtained from Thales.</p>
                                    </li>
                                    <li><b>method</b> (Required)
                                    <p>
                                            allaboutme.pcs.get_top_voted</p>
                                    </li>
                                    <li><b>start_date</b> (Required)
                                    <p>
                                            The start of the desired time period. The format is &quot;yyyy-mm-dd&quot;. The time period
                                        includes the start date.</p>
                                    </li>
                                    <li><b>end_date</b> (Required)
                                    <p>
                                            The end of the desired time period. The format is &quot;yyyy-mm-dd&quot;. The time period
                                        excludes the end date.</p>
                                    </li>
                                    <li><b>page_size</b> (Optional)
                                    <p>
                                            The number of designs in the pages. If not specified, this defaults to <em>10</em>.</p>
                                    </li>
                                    <li><b>custom_images_only</b> (Optional)
                                    <p>
                                            Restricts the card designs listed to those that use a custom image. Accepted values
                                        are &quot;true&quot; or &quot;false&quot;.</p>
                                    </li>
                                </ul>
                                <br />
                            </div>
                            <div>
                                <h3>
                                    Example response XML payload</h3>
                                <p>
                                    The &quot;Design&quot; tags are ordered by the &quot;votes&quot; attribute from most to least votes.</p>
                                <pre>
                                        &lt;Designs&gt;<br />&emsp;&emsp;
                                        &lt;Design card_image_id=&quot;1234567&quot; handover_key=&quot;222E5AB7-57EF-4f91-A261-37DDB2BC44BE&quot;
                                                            timestamp=&quot;2006-09-09 13:00:00&quot; votes=&quot;20&quot; /&gt;<br />&emsp;&emsp;
                    &lt;Design card_image_id=&quot;1234568&quot; handover_key=&quot;222E5AB7-57EF-4f91-A261-37DDB2BC44BE&quot;
                                                            timestamp=&quot;2006-09-09 13:45:00&quot; votes=&quot;11&quot; /&gt;<br />
                &lt;/Designs&gt;
                        </pre>
                                <br />
                            </div>
                            <div>
                                <h3>
                                    Error codes</h3>
                                <ul>
                                    <li><b>-1 (General error)</b>
                                        <p>
                                            An internal error ocurred on the server. This is not dependent on the specific method
                                        or parameters passed. If the error persists, contact Thales.</p>
                                    </li>
                                    <li><b>1 (Invalid api_key)</b>
                                        <p>
                                            The <em>api_key</em> passed is not valid or is disabled. Check the key to make sure
                                        it is correct. If so, contact Thales.</p>
                                    </li>
                                    <li><b>2 (Invalid method)</b>
                                        <p>
                                            The method you attempted to call is invalid. Check the <em>method</em> parameter.</p>
                                    </li>
                                    <li><b>3 (No method specified)</b>
                                        <p>
                                            The required <em>method</em> parameter was not informed.</p>
                                    </li>
                                    <li><b>401 (No start_date specified)</b>
                                        <p>
                                            The required <em>start_date</em> parameter was not informed.</p>
                                    </li>
                                    <li><b>402 (No end_date specified)</b>
                                        <p>
                                            The required <em>end_date</em> parameter was not informed.</p>
                                    </li>
                                </ul>
                                <br />
                            </div>
                        </div>
                        <div className="document-content-back">
                            <Link className="document-content-link" to='/technical/competitionapi'>Back</Link>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default GetTopVoted;